import { useSelector } from 'react-redux';
import { getDate, getTime } from 'booking/redux/selectors';
import { TimeSlotsControls } from 'booking/lib/types';
import useTimeSlotsHook from 'booking/hooks/useTimeSlots';
import useLocationData from 'booking/hooks/useLocationData';

export default function useTimeSlots(
    locationId: string,
    useWeeklySchedule: boolean,
): TimeSlotsControls {
    const initialDate = useSelector(getDate);
    const initialTime = useSelector(getTime);
    const location = useLocationData(locationId);

    return useTimeSlotsHook({
        initialDate,
        initialTime,
        locationId,
        locationOpenDate: location?.openDate,
        useWeeklySchedule,
    });
}
